import type { Board } from "../board";
import { CollectableItem, type CollectablePickupResult, type UseItemResult } from "../collectableItem";
import { CircleEffect } from "../effects/circleEffect";
import { Event } from "../events/event";
import { EventParameter } from "../events/eventParameter";
import { EventType } from "../events/eventType";
import type { Player } from "../player";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";

export class Medikit extends CollectableItem {
	static key = "Medikit";

	pickupBy(player: Player, board: Board): CollectablePickupResult {
		player.inventory.addItem(this);
		board.stats.recordItemCollected(Medikit.key, this.count);

		const event = new Event(EventType.GOT_ITEM);
		event.setParameter(EventParameter.AMMO_AMOUNT, String(this.count));
		event.setParameter(EventParameter.AMMO_NAME, this.getNameKey());
		board.addEvent(event);

		return { pickupKey: Medikit.key, amount: this.count, isInfinite: false };
	}

	isUsable(): boolean {
		return true;
	}

	getHotkeyLabel(): string {
		return "H";
	}

	use(player: Player, board: Board): UseItemResult {
		if (player.hp >= player.maxHp) {
			board.addEvent(new Event(EventType.CANT_HEAL_ALREADY_FULL_HEALTH));
			return { consumed: false, turnPassed: false };
		}

		const hpBefore = player.hp;
		const healAmount = Math.floor(player.maxHp / 5);
		player.hp = Math.min(player.hp + healAmount, player.maxHp);
		const actualHeal = player.hp - hpBefore;
		if (actualHeal > 0) board.stats.recordHealing(actualHeal);

		board.addNonPhysicalThing(new Sound(SoundId.HEALING_SPRAY));
		board.addEffect(new CircleEffect(player.xy));

		if (player.hp >= player.maxHp) {
			board.addEvent(new Event(EventType.PLAYER_FULLY_HEALED));
		} else {
			board.addEvent(new Event(EventType.PLAYER_HEALED));
		}

		return { consumed: true, turnPassed: true };
	}

	static deserialize(data: any): Medikit {
		return new Medikit(data.count);
	}
}
